import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const TechSupport = (props: SvgIconT.Props) => (
  <SvgIcon
    width={24}
    height={24}
    {...props}
    viewBox="0 0 24 24"
    paths={[
      'M7.98 3.166c2.756 0 5 2.242 5 5 0 .704-.149 1.391-.44 2.042l-.283.629.488.487 7.927 7.927a1.123 1.123 0 0 1-.793 1.914c-.3 0-.581-.116-.793-.328l-7.92-7.92-.49-.49-.631.287c-.658.3-1.353.452-2.066.452-2.757 0-5-2.243-5-5 0-.47.068-.938.2-1.387l3.093 3.094.293.293h3.414V6.75l-.293-.293-3.094-3.094c.45-.13.917-.198 1.387-.198m0-1c-1.144 0-2.209.325-3.118.88l4.118 4.12v2h-2l-4.118-4.12a5.962 5.962 0 0 0-.882 3.12 6 6 0 0 0 6 6c.886 0 1.723-.197 2.48-.542l7.92 7.92c.414.414.957.621 1.5.621s1.085-.207 1.5-.62a2.121 2.121 0 0 0 0-3l-7.927-7.928a5.97 5.97 0 0 0 .527-2.451 6 6 0 0 0-6-6z',
    ]}
  />
);

export default TechSupport;
